export default [
  {
    label: 'iPhone',
    value: 'ios'
  },
  {
    label: 'Android',
    value: 'android'
  }
]
